import {ReactElement, ReactNode} from "react";
import * as css from "./styles/DnDKitDropzone.module.scss";
import {useDroppable} from "@dnd-kit/core";
import cn from "classnames";

export interface DnDKitDropzoneProps {
    id: string;
    noChildren?: ReactNode;
    children?: ReactNode | ReactNode[];
}

export function DnDKitDropzone(props: DnDKitDropzoneProps): ReactElement {
    const {isOver, setNodeRef} = useDroppable({
        id: props.id
    });
    let children: ReactNode | ReactNode[] = props.children;
    if(!props.children || (Array.isArray(props.children) && props.children.length === 0)) {
        if(props.noChildren === undefined) {
            children = <></>;
        } else {
            children = props.noChildren;
        }
    }

    let className = css.dndkitDropzone;
    if(isOver) {
        className = cn(css.dndkitDropzone, css.isOver);
    }

    return <div ref={setNodeRef} className={className}>
        {children}
    </div>;
}